import React, { useEffect, useState } from "react";
import "./GovtTaxCheckBox.css";
import { Box, Checkbox, Divider, Grid } from "@mui/material";
import { fonts, themes } from "../../themes/themes";
import _ from "lodash";
import { getAmount } from "../../configs/utils";

interface contentTileType {
  getNewAssignedTaxes: (data: any) => void;
  data: any;
  assignedTaxesToEmployees: any;
  currency: any;
}
const GovtTaxCheckBox: React.FC<contentTileType> = ({
  getNewAssignedTaxes,
  data,
  assignedTaxesToEmployees,
  currency,
}) => {
  const [selectedTax, setSelectedTax] = useState<any>(assignedTaxesToEmployees);

  const handleSelect = (taxId: any) => {
    const tempArray: any = [...selectedTax];
    const foundElement = tempArray.find((id: any) => id == taxId);
    if (typeof foundElement !== "undefined") {
      _.remove(tempArray, (id: any) => {
        return id == taxId;
      });
    } else {
      tempArray.push(taxId);
    }
    setSelectedTax(tempArray);

    getNewAssignedTaxes(tempArray);
  };
  useEffect(() => {
    getNewAssignedTaxes(assignedTaxesToEmployees);
  }, []);
  return (
    <div>
      <Grid
        container
        style={{
          display: "flex",
          width: "600px",
          height: "400px",
          paddingBottom: "1em",
          overflowY: "auto",
        }}
        spacing={2}
      >
        {_.map(data, (tax: any) => {
          const allowances = _.map(tax?.tax_allowances, "allowance_type.name");

          return (
            <div>
              <Grid item>
                <Box className="govtTax-checkBox-container">
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontFamily: fonts.fontFamily,
                    }}
                  >
                    <Checkbox
                      checked={selectedTax.includes(Number(tax.id))}
                      onChange={(e) => handleSelect(tax.id)}
                    />
                    {tax?.name}
                  </Grid>

                  <Grid
                    container
                    style={{
                      backgroundColor: "#F5F5FA66",
                      borderRadius: "10px",
                      height: "auto",
                      width: "250px",
                      padding: "12px",
                    }}
                  >
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: themes.greySubtitle,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      Tax For
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "right",
                        color: themes.greySubtitle,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      Value
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: themes.blackDefault,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      {tax.applicable_on}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "right",
                        color: themes.lightRedSubtittle,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      {tax.tax_type === 0 ? `${tax.value}%` : `${tax.value}`}
                    </Grid>
                    <Divider />
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: themes.greySubtitle,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      Salary Range
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "right",
                        color: themes.greySubtitle,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      Applicable For
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "left",
                        color: themes.blackDefault,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      {`${currency} (${
                        tax?.salary_from ? getAmount(tax?.salary_from) : 0
                      }-${tax?.salary_to ? getAmount(tax?.salary_to) : 0})`}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        textAlign: "right",
                        color: themes.blackDefault,
                        fontSize: fonts.subtitle,
                        fontFamily: fonts.fontFamily,
                      }}
                    >
                      {allowances?.toString()}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </div>
          );
        })}
      </Grid>
    </div>
  );
};

export default GovtTaxCheckBox;
